import { Component, Input, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { Subscription } from 'rxjs';
import { TylerMatTableDataSource } from '../../../shared-components/angular-material/extended.class';
import { YearService } from '../../../shared-components/year/year.service';
import { VisionScreening } from '../health.model';
import { HealthService } from '../health.service';

@Component({
  selector: 'app-vision',
  templateUrl: './vision.component.html',
  styles: [
  ]
})
export class VisionComponent implements OnInit {

  @Input() selectedStudent;
  isBusy = false;
  visionScreenings: VisionScreening[] = [];
  student360YearSubscription: Subscription;

  // ----------Angular Material------------------------------------
  angularMatData = new TylerMatTableDataSource();
  columnsToDisplay = ['Date', 'VisionTest', 'BinocularNear', 'BinocularFar', 'AcuityFarRight', 'AcuityFarLeft', 'AcuityNearRight', 'AcuityNearLeft', 'MuscularNear', 'MuscularFar', 'ColorVision', 'LPhor', 'VPhor', 'Hyperopia', 'Glasses', 'UnderDoctorsCare', 'Referral', 'ReferralReturnedToSchool', 'ReturnDate'];
  @ViewChild(MatSort) sort: MatSort;

  constructor(
    private yearService: YearService,
    private healthService: HealthService
  ) {
    this.angularMatData = new TylerMatTableDataSource(this.visionScreenings);

    this.student360YearSubscription = this.yearService.observableStudent360YearStream$.subscribe(() => {
      this.getVisionScreenings();
    });
  }

  ngOnInit(): void {
    this.getVisionScreenings();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.selectedStudent.previousValue != undefined) {
      if (changes.selectedStudent.currentValue.Id != changes.selectedStudent.previousValue.Id) {
        this.getVisionScreenings();
      }
    }
  }

  ngOnDestroy(): void {
  }

  getVisionScreenings() {
    this.isBusy = true;
    setTimeout(() => {
      this.healthService.getVisionScreenings(this.selectedStudent.Id, this.yearService.student360Year.Id).subscribe(data => {
        this.visionScreenings = data;
        this.angularMatData = new TylerMatTableDataSource(this.visionScreenings);
        setTimeout(() => {
          this.angularMatData.sort = this.sort;
        }, 0);
        this.isBusy = false;
      });
    }, 0);
  }
}